<!-- HEAD -->
<app-main-head id="urp-container" [breadcrumbItems]="breadcrumbItems" [isSearchRequired]="false"
    [breadcrumbItems]="breadcrumbItems" [mainTitle]="'URP.URP'" [isRightPanelVisible]="false">
</app-main-head>
<!-- END HEAD -->

<app-URP-body></app-URP-body>